export default __webpack_public_path__ + "static/media/transaction1.aa21769f.svg";